// @flow
import React, { Component } from 'react';
import type { FileType } from 'state/types';

type FileTypeProps = {
  disabled: ?boolean,
  fileType: FileType,
  name: string,
  toggleFileTypeEnabled: Function,
  selectFileType: Function,
  isSelected: boolean,
  onClick: Function,
  onKeyDown: Function,
};

export default class FileTypeComponent extends Component<FileTypeProps> {
  handleEnable: Function;
  handleKeyDown: Function;
  handleSelect: Function;

  constructor() {
    super();
    this.handleEnable = this.handleEnable.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleEnable() {
    const { toggleFileTypeEnabled, name, fileType, disabled } = this.props;
    if (!disabled) {
      toggleFileTypeEnabled(fileType.enabled === false, name, fileType);
    }
  }

  handleSelect(e: SyntheticMouseEvent<>) {
    e.stopPropagation();
    const { onClick, selectFileType, name, disabled } = this.props;
    if (!disabled) {
      const selectState: Object = onClick(e, name);
      if (selectState) {
        selectFileType(selectState);
      }
    }
  }

  handleKeyDown(e: SyntheticKeyboardEvent<>) {
    const { disabled, onKeyDown, selectFileType } = this.props;
    if (!disabled) {
      const selectState: Object = onKeyDown(e);
      if (selectState) {
        selectFileType(selectState);
      }
    }
  }

  render() {
    const { fileType, name, isSelected, disabled } = this.props;
    const id = 'filetype-' + name;
    return (
      <div
        className={`field filetype ${isSelected ? 'selected' : ''}`}
        data-test-name="file-types-component"
        tabIndex="0"
        onKeyDown={this.handleKeyDown}
      >
        <input
          className="is-checkradio is-small"
          checked={fileType.enabled}
          disabled={disabled}
          id={id}
          onChange={this.handleEnable}
          type="checkbox"
          data-test-name={id}
        />
        <label style={{ marginRight: 0, paddingRight: 0 }} htmlFor={id} />
        <span
          className={`filetype-name ${disabled ? 'filetype-disabled' : ''}`}
          onClick={this.handleSelect}
        >
          {name}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Pages/CatalogsPage/FileTypeComponent.js